import { FC, useEffect, useState } from 'react';
import { Avatar, Button, Dropdown, Menu } from 'antd';
import { TbDots, TbPlugX } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useMaps } from '@/hooks/useMaps';
import { DropdownMenuPanel, VirtualizedList as List } from '@/shared';
import RenameResourceModal from '@/shared/components/modals/ResourceActionModals/01-RenameResourceModal';
import { toast } from '@/shared/components/toasts/PlatformToast';
import { useConnectedAccountStore } from '@/stores';
import { imgLogoStyling } from '@/theme';
import { ConnectedAccount, ConnectedAccountType } from '@/types';
import { formatDate } from '@/utilities';

interface ConnectedAccountListItemProps {
    i: ConnectedAccount;
}

const ConnectedAccountListItem: FC<ConnectedAccountListItemProps> = ({ i }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { deleteConnectedAccount } = useConnectedAccountStore();

    const handleDisconnectConnectedAccount = async () => {
        deleteConnectedAccount(i?.id).then(() => {
            toast('Account Disconnected', {
                icon: <TbPlugX size='1rem' />,
                description: i?.type,
            });
        });
    };

    const { token } = useAntDesignTheme();

    const { integrationLabelToIconMap } = useMaps();

    const [renameOpen, setRenameOpen] = useState(false);

    return (
        <>
            <List.Item
                key={i?.id}
                extra={
                    <Dropdown
                        trigger={['click']}
                        placement='bottomRight'
                        popupRender={() => (
                            <DropdownMenuPanel>
                                {/* <Menu.Item
                                    key='rename'
                                    icon={<TbEdit size='1rem' />}
                                    onClick={() => setRenameOpen(true)}
                                >
                                    Rename Connection
                                </Menu.Item>
                                <Menu.Divider /> */}
                                <Menu.Item
                                    danger
                                    icon={<TbPlugX size='1rem' />}
                                    key='disconnect'
                                    onClick={handleDisconnectConnectedAccount}
                                >
                                    Disconnect Service
                                </Menu.Item>
                            </DropdownMenuPanel>
                        )}
                    >
                        <Button disabled={loading}>
                            <TbDots
                                size='1rem'
                                style={{
                                    verticalAlign: '-0.175rem',
                                    color: token.colorTextTertiary,
                                }}
                            />
                        </Button>
                    </Dropdown>
                }
                style={{ padding: '0.5rem 0' }}
            >
                <List.Item.Meta
                    avatar={
                        <Avatar
                            style={{
                                marginTop: '0.25rem',
                                backgroundColor: token.colorBgBase,
                                border: `1px solid ${token.colorBorder}`,
                            }}
                            size='large'
                            shape='square'
                            icon={
                                <img
                                    alt={i?.type}
                                    src={integrationLabelToIconMap[i?.type as ConnectedAccountType]}
                                    style={{
                                        ...imgLogoStyling,
                                        transform: 'scale(0.75)',
                                    }}
                                />
                            }
                        />
                    }
                    title={<span style={{ fontWeight: 500 }}>{i?.nickname ? i?.nickname : i?.type}</span>}
                    description={<small>Connected {i?.createdAt && formatDate(i?.createdAt)}</small>}
                />
            </List.Item>
            <RenameResourceModal
                resource={i}
                singularResource={'connected-account'}
                open={renameOpen}
                setOpen={setRenameOpen}
            />
        </>
    );
};

export default ConnectedAccountListItem;
